import type { TokenCreateResponse } from './types';

export class AuthAPI {
  public tokens = {
    async create(): Promise<TokenCreateResponse> {
      return { token: 'local-token' };
    },
  };
}
